<script>
import { mapActions, mapGetters } from 'vuex'
import get from 'lodash/get'
import providerForm from './provider-form'

export default {
  name: 'ProviderNew',
  page: {
    title: 'New Provider',
  },
  components: {
    providerForm,
  },
  data: function() {
    return {
      provider: null,
      loading: false,
      backRoute: { name: 'providers' },
    }
  },
  computed: {
    ...mapGetters('me', {
      meProviderId: 'providerId',
      canSearchProvider: 'canSearchProvider',
    }),
    providerName() {
      return get(this.provider, 'name')
    },
    providerId() {
      return this.$route.params.id || this.meProviderId
    },
  },
  watch: {
    providerId() {
      this.fetchProvider()
    },
  },
  created() {
    this.fetchProvider()
  },
  methods: {
    ...mapActions('providers', {
      getProvider: 'GET_PROVIDER',
    }),
    async fetchProvider() {
      if (this.providerId) {
        this.loading = true
        const [error, response] = await this.getProvider(this.providerId)

        if (error) {
          this.$router.replace(this.backRoute)
        } else {
          this.provider = response
        }

        this.loading = false
      }
    },
  },
}
</script>

<template>
  <main-layout
    :title="providerName || 'New Provider'"
    :loading="loading"
    :back="canSearchProvider ? backRoute : false"
  >
    <data-box :status="false">
      <provider-form :provider="provider" />
    </data-box>
  </main-layout>
</template>
